import React from 'react'
import styled from 'styled-components'

export const STATUS_DOT = {
  ACTIVE: 'active',
  ERROR: 'error',
  WARNING: 'warning',
  INACTIVE: 'inactive',
}

const MAP_STATUS_DOT_COLOR = {
  [STATUS_DOT.ACTIVE]: 'var(--positive-color)',
  [STATUS_DOT.ERROR]: 'var(--negative-color)',
  [STATUS_DOT.WARNING]: 'var(--warning-color)',
  [STATUS_DOT.INACTIVE]: '#AAABBB',
}

const DotHandler = styled.div`
  &::before {
    width: 8px;
    height: 8px;
    ${({ size }) =>
      size === 'small' &&
      `
  width: 6px;
  height: 6px
  `}
    margin-right: 8px;
    border-radius: 50%;
    content: ' ';
    display: block;
    background-color: ${({ status }) => MAP_STATUS_DOT_COLOR[status]};
  }
`

const StatusDot = ({ id = 'status-dot-id', size = 'default', status = 'inactive' }) => (
  <DotHandler id={id} size={size} status={status} />
)

export default StatusDot
